module.exports = __webpack_public_path__ + "img/55.b12ecc7.jpg";